<template>
  <div>
    <el-form label-position="left" label-width="200px" :model="loginInfo">
      <el-form-item :label="`${$t('langcfg.txtUserName')}:`">
        <el-input
          autofocus
          style="margin-left: 10px"
          v-model="loginInfo.username"
          @click.native.stop.prevent="handleClick('username')"
          @touchend.native.stop.prevent="handleClick('username')"
        ></el-input>
      </el-form-item>
      <br />
      <el-form-item :label="`${$t('langcfg.txtPassword')}:`">
        <el-input
          show-password
          style="margin-left: 10px"
          v-model="loginInfo.password"
          @click.native.stop.prevent="handleClick('password')"
          @touchend.native.stop.prevent="handleClick('password')"
        ></el-input>
      </el-form-item>
      <br />
      <!-- <el-form-item :label="`${$t('langcfg.txtServer')}:`">
        <div class="protocol-url">
          <select class="protocol" v-model="loginInfo.ssl">
            <option :value="0">http://</option>
            <option :value="1">https://</option>
          </select>
          <input
            class="url"
            v-model="loginInfo.url"
            @click.stop.prevent="handleClick('url')"
            @touchend.stop.prevent="handleClick('url')"
          />
        </div>
      </el-form-item> -->
    </el-form>
    <br />
    <el-form label-width="200px">
      <el-form-item>
        <el-row>
          <el-col :span="12"
            ><el-button
              class="btn-oprator"
              @click="loginClick()"
              style="font-size: 25px; width: 150px; height: 60px; margin-left: 23px"
              >{{ $t("langcfg.txtLogin") }}</el-button
            ></el-col
          >
          <el-col :span="12">
            <el-button
              class="btn-oprator"
              v-if="isZHCN"
              @click="thirdClick()"
              style="font-size: 25px; width: 150px; height: 60px"
              >{{ $t("langcfg.txtThirdParty") }}</el-button
            >
          </el-col>
        </el-row>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import EVENTS from "../../../bus";
import { objectCopy } from "../../../shared/utils";
export default {
  data() {
    return {
      loginInfo: {
        username: "Admin",
        password: "",
        url: "127.0.0.1:8080",
        ssl: 0,
        isZHCN: false
      }
    };
  },
  created() {
    this.isZHCN = window.settings.language === "zh_CN";
  },
  mounted() {
    this.loginInfo = objectCopy(this.loginInfoForm);
    if (!this.loginInfo.url && this.loginInfo.serverip) {
      this.loginInfo.url = `${this.loginInfo.serverip}:${this.loginInfo.serverport}`;
      this.loginInfo.ssl = this.loginInfo.serverssl;
    }
  },
  updated() {
    this.isZHCN = window.settings.language === "zh_CN";
  },
  methods: {
    handleClick(key) {
      let self = this;

      this.$bus.$emit(EVENTS.spreadKeyBoard, self.loginInfo[key], (value) => {
        self.loginInfo[key] = value;
      });
    },
    loginClick() {
      this.$emit("login", this.loginInfo);
    },
    thirdClick() {
      this.$emit("thirdparty-click", "thirdparty");
    }
  },
  props: {
    loginInfoForm: {
      type: Object,
      default: () => {
        return {
          username: "Admin",
          password: "",
          url: "127.0.0.1:8080",
          ssl: 0
        };
      }
    }
  }
};
</script>
<style lang="less" scoped>
.el-form /deep/ .el-form-item__label {
  font-size: 30px;
  padding: 0px;
  line-height: 50px;
}

/deep/.el-form-item__error {
  margin-left: 20px;
}

.el-form-item {
  line-height: 40px;
  // margin-top: 20px;
}

.Login {
  width: 800px;
  padding-left: 20px;
}

.login-tip {
  font-size: 20px;
  width: 100%;
  text-align: left;
  margin-left: 20px;
}

.login-tip-undo {
  color: white;
}

.login-tip-doing {
  color: white;
}

.login-tip-unlogined {
  color: white;
}

.login-tip-failed {
  color: white;
}

.protocol-url {
  display: inline-flex;
  width: 100%;
  margin-left: 20px;
  font-size: 20px;
}

.protocol {
  border: #dcdfe6;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  border-right: none;
  font-size: 30px;
  background: white;
  outline: none;
  height: 50px;
  color: #606266;
}

.url {
  width: 100%;
  border: none;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  border-right: none;
  font-size: 30px;
  outline: none;
  height: 50px;
  color: #606266;
}

.btn-oprator {
  border: 1px gray solid;
  height: @header-fs+50px;
}

.btn-oprator:hover {
  color: @btn-hover-color;

  i {
    color: @btn-hover-color;
  }
}
input[type="checkbox"] {
  padding: 0px;
  border: none;
  width: 35px;
  height: 35px;
  margin-left: 30px;
}
.btn-oprator:active {
  background: @btn-active-color;
}
</style>



// WEBPACK FOOTER //
// src/mainInterface/components/settings/FormLogin_old.vue